@if (formFieldSignal(); as formField) {
    <div class="input-button-group flex">
        <input #input [readonly]="readOnlyOverride || formField.IsReadOnly"
               [class.error]="errorState != null"
               [tabIndex]="readOnlyOverride || formField.IsReadOnly ? -1  : 0" [formControl]="formControl"
               placeholder="{{formField.Placeholder}}" id="{{formField.Id}}" type="url">
        <div class="button-group">
            <button [disabled]="disableLinkButton"
                    [class.error]="errorState != null"
                    class="default !px-2 !py-1" type="button" (click)="navigateToLink()">
                <bizz-icon class="h-4 w-4" iconName="globe">
                </bizz-icon>
            </button>
        </div>
    </div>
}
